// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__1ZHTf","logo__img":"styles_logo__img__3J-ux","logo__cursor_on":"styles_logo__cursor_on__15kvh"};